<div class="certificate-reload-dialog">
  <span [innerHTML]="message"></span>
  <mat-progress-bar
    class="reload-progress"
    color="primary"
    mode="determinate"
    [value]="progressBarValue">
  </mat-progress-bar>
</div>
